import { render, staticRenderFns } from "./statement-diff.vue?vue&type=template&id=0cd47449&scoped=true"
import script from "./statement-diff.vue?vue&type=script&lang=js"
export * from "./statement-diff.vue?vue&type=script&lang=js"
import style0 from "./statement-diff.vue?vue&type=style&index=0&id=0cd47449&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd47449",
  null
  
)

export default component.exports